

import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Card, Grid, Snackbar, Alert } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import DataLoadingSpinner from "components/Spinners/DataLoadingSpinner";
import { useAuth } from 'auth/Auth';
import { formatDate } from 'utils/DateTimeConversion';

const ReferralCodeDetail = () => {
    const { id } = useParams();
    const { axiosInstance } = useAuth();
    const [code, setCode] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

    useEffect(() => {
        if (id) {
            fetchCodeDetail();
        }
    }, [id]);

    const fetchCodeDetail = async () => {
        setIsLoading(true);
        try {
            const response = await axiosInstance.get(`/referral-codes/${id}`);
            setCode(response.data);
        } catch (error) {
            console.error('Error fetching referral code details:', error);
            setSnackbar({ open: true, message: 'Error loading referral code details', severity: 'error' });
        } finally {
            setIsLoading(false);
        }
    };

    if (isLoading) {
        return (
            <DashboardLayout>
                <DashboardNavbar />
                <DataLoadingSpinner title="Loading Referral Code Details" message="Please wait..." />
                
            </DashboardLayout>
        );
    }

    if (!code) {
        return (
            <DashboardLayout>
                <DashboardNavbar />
                <MDBox p={6}><MDTypography color="error">Referral Code not found</MDTypography></MDBox>
                
            </DashboardLayout>
        );
    }

    const mainInfo = {
        "Name": code.name,
        "Code": code.code,
        "Referrer": code.referrer?.name || code.referrer_id || '-',
        "Status": code.status,
        "Expiration Date": code.expiration_date ? formatDate(code.expiration_date) : '-',
    };

    const renderDetailCard = (title, data) => (
        <MDBox m={3} p={3} borderRadius="lg" sx={{ backgroundColor: 'white', boxShadow: 3 }}>
            <MDTypography variant="h6" fontWeight="medium" color="dark" mb={2}>
                {title}
            </MDTypography>
            <Grid container spacing={3}>
                {Object.entries(data).map(([key, value]) => (
                    <Grid item xs={12} sm={6} key={key}>
                        <MDBox display="flex" alignItems="center">
                            <MDTypography variant="button" fontWeight="bold" color="text">
                                {key}:
                            </MDTypography>
                            <MDTypography fontSize="0.9rem" color="text" ml={1}>
                                {value}
                            </MDTypography>
                        </MDBox>
                    </Grid>
                ))}
            </Grid>
        </MDBox>
    );

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox mx={2} mt={-3} py={3} px={2} variant="gradient" bgColor="info" borderRadius="lg" coloredShadow="info">
                                <MDTypography variant="h6" color="white">
                                    Referral Code Details: {code.name}
                                </MDTypography>
                            </MDBox>
                            <MDBox>
                                {renderDetailCard('Referral Code Information', mainInfo)}
                            </MDBox>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            
            <Snackbar
                open={snackbar.open}
                autoHideDuration={6000}
                onClose={() => setSnackbar({ ...snackbar, open: false })}
            >
                <Alert severity={snackbar.severity} onClose={() => setSnackbar({ ...snackbar, open: false })}>
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </DashboardLayout>
    );
};

export default ReferralCodeDetail;

